export default "__VITE_ASSET__CECgBlNl__"